export default "__VITE_ASSET__Px6Yc6hF__"